'use strict'

import angular from "angular";
import './activityLog.service';
import './activityLog.controller';

import activityLogTemplateUrl from "./activityLog.html";

angular.module('activityLog', ['activityLog.controllers', 'activityLog.services'])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider.state('activityLogs', {
            parent: 'layout',
            url: '/admin/activityLogs',
            templateUrl: activityLogTemplateUrl,
            controller: 'ActivityLogController'
        })
    }])